let routes = [
    {
        path: '/internationalization-management',
        name: 'internationalization-management',
        component: () => import('@/modules/managers/internationalizationManagement/InternationalizationManagement.vue')
    }
]

export default routes
